import { CSSProperties, FC } from 'react';
import { Helmet } from 'react-helmet';

export const VIEWER_VERSION = 'v1.0.0';

// Inline, e não só no `loader.css`: no F5 o motor monta antes do CSS chegar e,
// vendo o container `static`, o posicionaria por conta própria sem altura.
export const BIM_CONTAINER_STYLE: CSSProperties = { position: 'absolute', inset: 0 };

/** O loading padrão do motor; o estilo vem do `loader.css` do bundle. */
export const EngineSpinner: FC = () => (
  <>
    <Helmet>
      <link rel="stylesheet" type="text/css" href={`/coordly3DViewer/${VIEWER_VERSION}/css/loader.css`} />
    </Helmet>
    <div className="x-spinner-container">
      <div className="x-spinner"></div>
    </div>
  </>
);
